import request from '@/utils/request'
import type { AxiosResponse } from 'axios'
import type { LaravelResource } from '../types'

export interface HelpText {
  text: string
  button: string
  [key: string]: string
}

/** GET /api/v2/static/help */
export function getHelpText(): Promise<AxiosResponse<LaravelResource<HelpText>>> {
  return request({
    url: '/api/v2/static/help',
    method: 'get',
  })
}
